// Module
var code = `<div class="modal-dialog modal-lg edit-document-warnings" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-bind="click: cancel" aria-hidden="true">
                <i class="icon-cancel"></i>
            </button>
            <h4 class="modal-title"><span data-bind="text: textForTitle"></span><span> Warnings</span></h4>
        </div>
        <div class="modal-body">
            <div class="margin-top">
                The following detected warnings might affect the <span data-bind="text: textForTitle"></span> data:
            </div>
            <div data-bind="foreach: warningsList">
                <table class="table table-condensed table-striped table-bordered margin-top" data-bind="visible: warnings.length">
                    <thead>
                    <tr>
                        <th>Location in <span data-bind="text: source"></span></th>
                        <th>Description</th>
                    </tr>
                    </thead>
                    <tbody data-bind="foreach: warnings">
                    <tr>
                        <td nowrap="nowrap">
                            <a href="#" class="text-warning" data-bind="click: \$root.goTo.bind(\$root, \$data, \$parent.source), attr: { 'title': 'Go to warning in ' + \$parent.source + ' editor' }">
                                <i class="icon-warning text-warning"></i>
                                <span data-bind="text: \$root.warningLocation(\$data)"></span>
                            </a>
                        </td>
                        <td>
                            <span class="description" data-bind="text: text"></span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bind="click: cancel">Cancel</button>
            <button type="button" class="btn btn-primary" data-bind="click: confirm">Save anyway</button>
        </div>
    </div>
</div>
`;
// Exports
export default code;